import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import Knowledge from '../modules/knowledge/index'
import WechatShare from '../modules/wechatShare/index'
import AppointmentShare from '../modules/appointment/index'
import knowledgeShare from '../modules/knowledgeShare/index'
import ActivityOne from '../modules/activity/index'
import ActivityTwo from '../modules/activity/components/activityTwo'
import ActivityThree from '../modules/activity/components/activityThree'
import ActivityFour from '../modules/activity/components/activityFour'
import ActivityFive from '../modules/activity/components/activityFive'
import PrivacyAgreement from '../modules/activity/components/privacyAgreement'
import TdPrivacyAgreement from '../modules/activity/components/tdPrivacyAgreement'
import WxPrivacyAgreement from '../modules/activity/components/wxPrivacyAgreement'
import WxUserAgreement from '../modules/activity/components/wxUserAgreement'
import WxOcrPrivacyAgreement from '../modules/activity/components/wxOcrPrivacyAgreement'
import WxOcrUserAgreement from '../modules/activity/components/wxOcrUserAgreement'
import PrivacyAgreementJa from '../modules/activity/components/privacyAgreementJa'
import PrivacyAgreementTdJa from '../modules/activity/components/privacyAgreementTdJa'
import Theme from '../modules/theme/index'
import HuaweiSportRedirect from '../modules/sport'
import WxProgram from '../modules/wxProgram'
import BirthdayBlessing from '../modules/birthday'
import measureShare from '../modules/wechatShare/components/measureShare'
import Tel from '../modules/tel/index'
import VideoShare from '../modules/videoShare/index'

const SampleIndex = () => <Sample>共同照护新模式，糖尿病的福音！</Sample>

const routes = [
  {
    path: '/',
    exact: true,
    component: SampleIndex,
  },
  {
    path: '/knowledge/:systemType/:knowledgeId/:patientId/:fontSize/:isActivity',
    component: Knowledge,
  },
  {
    path: '/knowledge/:systemType/:knowledgeId/:patientId/:fontSize',
    component: Knowledge,
  },
  {
    path: '/knowledge/:systemType/:knowledgeId/:patientId',
    component: Knowledge,
  },
  {
    path: '/knowledge/:systemType/:knowledgeId',
    component: Knowledge,
  },
  {
    path: '/theme/:systemType/:themeId/:patientId',
    component: Theme,
  },
  {
    path: '/knowledge/:knowledgeId/:patientId',
    component: Knowledge,
  },
  {
    path: '/wechatShare/:patientId/:sugerValue',
    component: WechatShare,
  },
  {
    path: '/wechatShare/:data',
    component: WechatShare,
  },
  {
    path: '/appointment',
    component: AppointmentShare,
  },
  {
    path: '/activityOne',
    component: ActivityOne,
  },
  {
    path: '/activityTwo',
    component: ActivityTwo,
  },
  {
    path: '/activityThree',
    component: ActivityThree,
  },
  {
    path: '/activityFour',
    component: ActivityFour,
  },
  {
    path: '/activityFive',
    component: ActivityFive,
  },
  {
    path: '/knowledgeShare/:systemType/:knowledgeId/:patientId',
    component: knowledgeShare,
  },
  {
    path: '/knowledgeShare/:systemType/:knowledgeId',
    component: knowledgeShare,
  },
  {
    // 视频分享落地页(TAPD 1006913)。web-gateway 会把
    // wechat-share.../{prod|dev}/videoShare/<id> 302 到这里(去掉环境前缀)
    path: '/videoShare/:videoId',
    component: VideoShare,
  },
  {
    path: '/huaweiRedirect',
    component: HuaweiSportRedirect,
  },
  {
    path: '/wxProgramTest',
    component: WxProgram,
  },
  {
    path: '/birthdayBlessing/:patientId',
    component: BirthdayBlessing,
  },
  {
    path: '/measureShare/:measureResult/:textColor',
    component: measureShare,
  },
  {
    path: '/privacyAgreement',
    component: PrivacyAgreement,
  },
  {
    path: '/tdPrivacyAgreement',
    component: TdPrivacyAgreement,
  },
  {
    path: '/privacyAgreementJa',
    component: PrivacyAgreement,
  },
  {
    path: '/privacyAgreementTdJa',
    component: PrivacyAgreementTdJa,
  },
  {
    path: '/wxPrivacyAgreement',
    component: WxPrivacyAgreement,
  },
  {
    path: '/wxUserAgreement',
    component: WxUserAgreement,
  },
  {
    path: '/wxOcrPrivacyAgreement',
    component: WxOcrPrivacyAgreement,
  },
  {
    path: '/wxOcrUserAgreement',
    component: WxOcrUserAgreement,
  },
  {
    path: '/Tel',
    component: Tel,
  }
]

const getRouters = () => {
  return (
    <Router>
      <Switch>
        {routes.map(({ path, exact, component: Comp }) => (
          <Route
            key={path}
            path={path}
            exact={exact}
            render={(props) => <Comp {...props} />}
          />
        ))}
      </Switch>
    </Router>
  )
}
const Sample = styled.div`
  margin-top: 50px;
  text-align: center;
`
export default getRouters



// WEBPACK FOOTER //
// ./src/routers/index.js